import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { checklist, workOrder } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { QRCode } from "react-qrcode-logo";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  getStatusColor,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { PermissionChecker } from "../../components/PermissionChecker/index.jsx";


function Checklist() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1,take:10,totalData:1 });
  const [deleteRow, setDeleteRow] = useState(null);
  const { config } = useAuth();
  const navigate = useNavigate();

  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await checklist.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData:data.totalData
          }))
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }
  


  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      minWidth: "150px",
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Created at",
      selector: (row) => row.created_at,
      cell: (row) => formatDateOnly(row.created_at),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex">
          <button
            className="btn btn-sm btn-outline-theme me-2"
            onClick={() => {
              navigate(`/checklist/edit/${row.id}`);
            }}
          >
            View
          </button>

          <PermissionChecker permissions={["delete checklist"]} hideIfNotAllowed>
          <button
            className="btn btn-sm btn-outline-danger ml-2"
            onClick={() => {
              showConfirmationDlg(row);
            }}
          >
            Delete
            </button>
            </PermissionChecker>

        </div>
      ),
    },
  ];

  
  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }
  

  async function deleteData() {
    try {
      const response = await checklist.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This checklist has been deleted");

          setDeleteRow(null);
          await getData()
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page,query.take]);


  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active"> Checklist</li>
          </ul>

          <h1 className="page-header">Checklist</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
             
              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    navigate("/checklist/add");
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Checklist <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    
                    <DataTable
                      progressPending={loading}
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                      pagination
                      paginationServer
                      onChangeRowsPerPage={(row)=>setQuery((prev)=>({...prev,page:1,take:row}))}
                      paginationTotalRows={query.totalData}
                      onChangePage={(page)=>setQuery((prev)=>({...prev,page:page}))}
                      
                      />
                
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

 
      
      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Checklist"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this checklist{" "}
            <strong>{deleteRow.name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
   
    </div>
  );
}

export default Checklist;
